
const selectFavourites = {
  namespaced: true,
  state: {
    addMarkets: false,
    selectFavouritesModal: false,
    marketFavouritesList: [],
    favCreated: false,
    favouriteOptionSelected: 0,
    favouriteListToFilter: "",
    showFilteredFavourites: false,
    favouriteFiltersToApply: [],
    serviceSelectedName: "",
    listOfServicesCreated: [],
    showConfirmationRemoveFavourite: false,
  },
  getters: {
  },
  actions: {
    openModal: ({ commit }) => {
      commit("OPEN_MODAL");
    },
    closeModal: ({ commit }) => {
      commit("CLOSE_MODAL");
    },
    favouritesCreated: ({ commit }) => {
      commit("FAV_CREATED");
    },
    insertFavourite: ({ commit }, payload) => {
      commit("INSERT_FAVOURITE", payload);
    },
    selectFavouriteOption: ({ commit, dispatch }, payload) => {
      commit("SELECT_FAVOURITE_OPTION", payload);
      //dispatch('addToServiceToList',payload)
    },
    openAddLocationModal: ({ commit }) => {
      commit("OPEN_ADD_LOCATION_MODAL");
    },
    closeAddLocationModal: ({ commit }) => {
      commit("CLOSE_ADD_LOCATION_MODAL");
    },
    openEditLocationModal: ({ commit }) => {
      commit("OPEN_EDIT_LOCATION_MODAL");
    },
    closeEditLocationModal: ({ commit }) => {
      commit("CLOSE_EDIT_LOCATION_MODAL");
    },
    updateFavouriteList: ({ commit }, payload) => {
      commit("UPDATE_FAVOURITE_LIST", payload);
    },
    addToServiceToList: ({ commit }, payload) => {
      commit("ADD_SERVICE_TO_LIST", payload);
    },
    updateFavouritesMarkets: ({ commit }, payload) => {
      commit("UPDATE_FAVOURITES_MARKETS", payload);
    },
    updateShowConfirmationRemoveFavourite: ({ commit }, payload) => {
      commit("UPDATE_SHOW_CONFIRMATION_REMOVE_FAVOURITE", payload);
    },
    updateNoFavouriteRemaining: ({ commit }) => {
      commit("UPDATE_NO_FAVOURITE_REMAINING");
    },
  },

  mutations: {
    OPEN_MODAL: (state) => {
      state.addMarkets = true;
      state.selectFavouritesModal = true;
    },
    CLOSE_MODAL: (state) => {
      state.selectFavouritesModal = false;
    },
    FAV_CREATED: (state) => {
      state.favCreated = true;
      state.selectFavouritesModal = false;
    },
    INSERT_FAVOURITE: (state, payload) => {
      state.marketFavouritesList.push(payload.favourites);
    },
    SELECT_FAVOURITE_OPTION: (state, payload) => {
      //get index and name of the service, Ex-Rack or....

      const { key, serviceName } = payload;
      state.favouriteOptionSelected = key;
      state.serviceSelectedName = serviceName;
    },
    UPDATE_FAVOURITE_LIST: (state, payload) => {
      state.favouriteListToFilter = payload;
    },
    FILTER_FAVOURITES: (state, payload) => {
      state.favouriteFiltersToApply = [];
      state.favouriteFiltersToApply = payload.filtersApplied;
      /* If filters selected are the same as default, set displayFilteredOffers to false */
      if (payload.showFilteredFavourites == false) {
        state.showFilteredFavourites = true;
      } else {
        state.showFilteredFavourites = false;
      }
    },
    ADD_SERVICE_TO_LIST: (state, payload) => {
      state.listOfServicesCreated.includes(payload.serviceName)
        ? ""
        : state.listOfServicesCreated.push(payload.serviceName);
    },
    UPDATE_FAVOURITES_MARKETS: (state, payload) => {
      state.marketFavouritesList = payload;

      /* Update list of services that have been added to favourites according to updated favourites */
      state.listOfServicesCreated = [];
      state.marketFavouritesList.forEach((market) => {
        if (!state.listOfServicesCreated.includes(market.type)) {
          state.listOfServicesCreated.push(market.type);
        }
      });
    },
    UPDATE_SHOW_CONFIRMATION_REMOVE_FAVOURITE: (state, payload) => {
      state.showConfirmationRemoveFavourite = payload;
    },
    UPDATE_NO_FAVOURITE_REMAINING: (state) => {
      state.favCreated = false;
    },
  },
};

export default selectFavourites